<template>
	<div
		class="accordion"
		:class="{
			'is-open': isOpen,
			'is-disabled': disabled,
		}"
	>
		<div
			v-tooltip="headerTooltip"
			class="accordion__header"
			@click="handleAccordionToggle"
		>
			<Title
				:title="title"
				:subtitle="subtitle"
				:tooltip-icon="icon"
				:tooltip-text="iconHint"
			/>
			<div class="accordion__toggle-indicator">
				<Icon
					icon-name="down-arrow"
				/>
			</div>
		</div>
		<div
			v-show="isOpen"
			class="accordion__content"
		>
			<slot />
		</div>
	</div>
</template>

<script>
import Title from '@videotools/js/components/Title/Title';

export default {
	name:       'Accordion',
	components: {
		Title,
	},
	props: {
		title: {
			type:     String,
			required: true,
		},
		subtitle: {
			type:    String,
			default: null,
		},
		icon: {
			type:    String,
			default: null,
		},
		iconHint: {
			type:    String,
			default: null,
		},
		open: {
			type:    Boolean,
			default: false,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		disabledHint: {
			type:    String,
			default: null,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	computed: {
		headerTooltip() {
			if (this.disabled && this.disabledHint) {
				return { content: this.disabledHint, classes: 'tooltip' };
			}
			return null;
		},
	},
	watch: {
		open(val) {
			this.isOpen = val;
		},
	},
	created() {
		this.isOpen = !!this.open;
	},
	methods: {
		handleAccordionToggle() {
			if (this.disabled) {
				return;
			}
			this.isOpen = !this.isOpen;
			this.$emit('toggle', this.isOpen);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/fonts';

.accordion {
	display: flex;
	flex-direction: column;
	color: var(--color-soft-white);
	border-bottom: 1px solid var(--color-grey-850);

	&.is-disabled {
		color: var(--color-grey-700);
	}
}

.accordion__toggle-indicator {
	transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s;

	.accordion.is-open & {
		transform: rotate(180deg);
	}
}

.accordion__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: $sp4;
	padding-bottom: $sp4;
	user-select: none;

	@media (hover:hover) {
		&:hover {
			cursor: pointer;
		}

		.accordion.is-disabled &:hover {
			cursor: not-allowed;
		}
	}
}

.accordion__content {
	padding-top: $sp4;
	padding-bottom: $sp4;
	position: relative;
}
</style>
